import React from "react";
import { withRouter, matchPath } from "react-router-dom";

export const withMatchedRouter = WrappedComponent => {
  const { displayName, name } = WrappedComponent;
  const componentName = displayName || name || "Component";

  const Decorated = withRouter(props => {
    const { location: { pathname } = {} } = props;
    const match = matchPath(pathname, props);
    return <WrappedComponent {...props} match={match} />;
  });

  Decorated.displayName = `MatchedRouter(${componentName})`;

  return Decorated;
};
